module.exports = __webpack_public_path__ + "img/team.235d9890.jpg";